import * as moment from "moment";
import { IAnnualSummaryByMonthRow } from "src/components/projects/project/reports/annualsummary/interfaces";
import { round, TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";

export function generateDualRateSummaryByMonth(
  projectId: string
): Promise<IAnnualSummaryByMonthRow[]> {
  return new Promise<IAnnualSummaryByMonthRow[]>(resolve => {
    const rows: IAnnualSummaryByMonthRow[] = [];
    const projectDocument = fs.fs.collection("projects").doc(projectId);
    projectDocument.get().then(projectDoc => {
      let checkEstimate: boolean = false;
      if (projectDoc.exists) {
        const { checkEstimatedGeneration } = projectDoc.data() as any;
        if (checkEstimatedGeneration === undefined) {
          checkEstimate = false;
        } else {
          checkEstimate = checkEstimatedGeneration;
        }

        projectDocument
          .collection("statements")
          .orderBy("statementDate")
          .get()
          .then(querySnapshot => {
            const promises: any[] = [];
            querySnapshot.forEach(doc => {
              if (doc.exists) {
                const {
                  statementDate,
                  totalAmountDue,
                  serviceStartDate,
                  serviceEndDate,
                  yearsWithSolar,
                } = doc.data() as any;

                const numberOfDays = round(
                  moment.duration(moment(serviceEndDate).diff(moment(serviceStartDate))).asDays(),
                  0
                );
                promises.push(
                  projectDocument
                    .collection("simpleDualRateStatements")
                    .doc(doc.id)
                    .get()
                    .then(simpleDoc => {
                      let totalFromGrid: number = 0;
                      // let onPeakFromGrid: number = 0;
                      let totalCredited: number = 0;
                      // let onPeakCredited: number = 0;
                      let generated: number = 0;

                      if (simpleDoc.exists) {
                        const {
                          totalElectricityFromGrid,
                          // onPeakElectricityFromGrid,
                          totalElectricityCredited,
                          // onPeakElectricityCredited,
                          solarGenerated,
                        } = simpleDoc.data() as any;

                        totalFromGrid = totalElectricityFromGrid ? totalElectricityFromGrid : 0;
                        // onPeakFromGrid = onPeakElectricityFromGrid ? onPeakElectricityFromGrid : 0;
                        totalCredited = totalElectricityCredited ? totalElectricityCredited : 0;
                        // onPeakCredited = onPeakElectricityCredited ? onPeakElectricityCredited : 0;
                        generated = solarGenerated ? solarGenerated : 0;
                      }

                      let avagEstimatedPower: number = 0;
                      let payment: number = 0;
                      let bPayment: number = 0;

                      projectDocument
                        .collection("guaranteedPowerTable")
                        .where("productionAnniversary", "==", yearsWithSolar)
                        .get()
                        .then(querySnapshot => {
                          if (checkEstimate) {
                            if (querySnapshot.size === 1) {
                              const {
                                averageEstimatedPower,
                                leasePayment,
                                budgetPayment,
                              } = querySnapshot.docs[0].data() as any;
                              avagEstimatedPower = averageEstimatedPower
                                ? averageEstimatedPower
                                : 0;
                              payment = leasePayment ? leasePayment : 0;
                              bPayment = budgetPayment ? budgetPayment : 0;
                            }
                          }
                        })
                        .then(() => {
                          let savings: number = 0;
                          const totalCost: number = totalAmountDue + payment;
                          if (avagEstimatedPower > 0 && payment > 0 && bPayment > 0) {
                            savings = bPayment - totalCost;
                          }
                          const percentSolarGenerated =
                            (generated / (totalFromGrid + (generated - totalCredited))) * 100.0;

                          setTimeout(() => {
                            rows.push({
                              id: doc.id,
                              statementDate: statementDate ? statementDate : Date.now(),
                              serviceStart: serviceStartDate ? serviceStartDate : Date.now(),
                              serviceEnd: serviceEndDate ? serviceEndDate : Date.now(),
                              numberOfDays,
                              totalDelivered: totalFromGrid,
                              totalSolarGenerated: generated,
                              metEstimatedGeneration: false,
                              checkEstimate,
                              avagEstimatedPower,
                              totalSolarRecived: totalCredited,
                              netGridUsage:
                                totalFromGrid - totalCredited < 0
                                  ? 0
                                  : totalFromGrid - totalCredited,
                              solarDirectlyUsed: generated - totalCredited,
                              totalHouseholdUsage: totalFromGrid + (generated - totalCredited),
                              percentSolarGenerated,
                              leasePayment: round(payment, 2),
                              electricBillAmount: round(totalAmountDue, 2),
                              totalCost: round(totalCost, 2),
                              budgetPayment: round(bPayment, 2),
                              electricitySavings: round(savings, 2),
                            });
                          }, TIMEOUT);
                        });
                    })
                );
              }
            });
            Promise.all(promises).then(() => {
              resolve(rows);
            });
          });
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/reports/DualRateSummaryByMonth.tsx